import {
    apiGetDeviceSelectors,
    apiGetFailedOrders,
    apiGetOrderDetail,
    apiGetOrders,
    apiGetOrdersDashboard,
    apiSendorder,
} from "../api/orders/orders";

interface OrderListOptions {
    limit: number;
    offset: number;
    search?: string;
    status?: string;
    date_after?:string;
    date_before?:string;
    target_device?:string;
}

export const orderService = {
    async getOrders(options: OrderListOptions) {
        return await apiGetOrders(options);
    },

    async getOrderDashboard() {
        return await apiGetOrdersDashboard();
    },

    async getDeviceSelector() {
        return await apiGetDeviceSelectors();
    },

    async getOrderDetail(id: string) {
        return await apiGetOrderDetail(id);
    },

    async getFailedOrders() {
        return await apiGetFailedOrders();
    },

    async sendOrder(id: string, device?: string) {
        return await apiSendorder(id, device);
    },
};
